import React from 'react';

interface SkeletonProps {
  className?: string;
  rows?: number;
}

export function SkeletonBlock({ className = '' }: { className?: string }) {
  return <div className={`skeleton rounded-md ${className}`} />;
}

export function SkeletonMetricCard() {
  return (
    <div className="rounded-xl border border-border bg-card p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between">
        <SkeletonBlock className="w-9 h-9 rounded-lg" />
        <SkeletonBlock className="w-12 h-4" />
      </div>
      <div className="space-y-1.5">
        <SkeletonBlock className="w-20 h-3" />
        <SkeletonBlock className="w-32 h-7" />
        <SkeletonBlock className="w-24 h-3" />
      </div>
    </div>
  );
}

export function SkeletonTableRow({ cols = 6 }: { cols?: number }) {
  return (
    <tr className="border-b border-border">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={`sk-col-${i + 1}`} className="px-4 py-3">
          <SkeletonBlock className="h-4 w-full" />
        </td>
      ))}
    </tr>
  );
}

export function SkeletonChartBlock({ height = 200 }: { height?: number }) {
  return <SkeletonBlock className="w-full rounded-lg" style={{ height: `${height}px` } as React.CSSProperties} />;
}

export default function LoadingSkeleton({ rows = 5 }: SkeletonProps) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonBlock key={`sk-row-${i + 1}`} className="h-12 w-full" />
      ))}
    </div>
  );
}